import React from 'react';
import SelectField from '../../forms/SelectField';
import { toSelectionFormat } from '../../../lib/collection.utils';

const BulkSetEventsInputs = ({ staticData = {}, data, onInput, dependencies = {} }) => {
    const events = dependencies.events || [];
    const selectedItems = staticData.selectedItems || staticData.selectedPartners || [];
    const itemLabel = staticData.itemLabel || 'media partner';
    const selectedEventIds = data.eventIds || [];

    return (
        <React.Fragment>
            <p className="u-margin-bottom-1">
                Select the events to assign to the selected{' '}
                <span className="u-bold">
                    {selectedItems.length} {itemLabel}
                    {selectedItems.length === 1 ? '' : 's'}
                </span>
                .
            </p>
            <p className="u-margin-top-2 u-margin-bottom-2" style={{ fontSize: '0.9em', color: '#666' }}>
                This will overwrite the current events for all selected {itemLabel}s.
            </p>
            <div className="ckp-admin-grid-column">
                <SelectField
                    name="eventIds"
                    label="Events"
                    onChange={onInput}
                    value={selectedEventIds}
                    multiple={true}
                    items={toSelectionFormat(events)}
                />
            </div>
        </React.Fragment>
    );
};

export default BulkSetEventsInputs;
